import * as React from 'react';
import MedicineService from '../../../services/medicineService';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import Spinner from '../../../common/components/spinner/spinner';
import { DriveAndMachineContentModel } from "../../../models/driveAndMachineContentModel";
import Translate from '../../../common/functions/translate';
import { connect } from 'react-redux';

interface IProps {
  medicineId: any,
  lang: string,
}

interface IState {
  isLoading: boolean;
  medicineId: number;
  error: any;
  driveMachine: DriveAndMachineContentModel;
}

class DriveMachineTab extends React.Component<IProps, IState> {
  medicineService = new MedicineService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      error: null,
      isLoading: false,
      medicineId: this.props.medicineId,
      driveMachine: new DriveAndMachineContentModel()
    };
  }

  componentDidMount() {
    this.getDriveMachineContent();
  }

  getDriveMachineContent = () => {
    this.setState({
      isLoading: true
    });

    this.medicineService.getDriveMachineContent(this.state.medicineId, this.props.lang).then(
      (data: any) => {
        this.setState({
          isLoading: false,
          driveMachine: data.data
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  public render() {

    var driveElement: any = null;
    const { medicineId, isLoading, error, driveMachine } = this.state;

    if (driveMachine) {
      driveElement =
        <div>
          {driveMachine.driveDescription
            ? <div style={{ marginBottom: "50px" }}>
              <h3>{Translate("DrivingAndUsingMachines")}</h3>
              <div dangerouslySetInnerHTML={{ __html: driveMachine.driveDescription }}></div>
            </div>
            : null}
          {/* {driveMachine.machineDescription
            ? <div>
              <h3>{Translate("When using machine")}</h3>
              <div dangerouslySetInnerHTML={{ __html: driveMachine.machineDescription }}></div>
            </div>
            : null} */}
        </div>;
    }
    else {
      driveElement = null;
    }

    return (
      <div>
        {isLoading ? <Spinner /> : null}
        {error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}
        {driveElement}
      </div>
    )
  }
}

const mapsStateToProps = state => {
  return {
    lang: state.common.lang
  };
}

export default connect(mapsStateToProps, null)(DriveMachineTab);